(function () {
  const form = document.querySelector(".submit_form");
  // const inputs = document.querySelectorAll("input");
  const email = document.getElementById("email");
  const username = document.getElementById("username");
  const password = document.getElementById("password");
  const password2 = document.getElementById("password2");

  //Input Error message function
  function errorMsg(input, msg) {
    const formGroup = input.parentElement;
    formGroup.className = "form-group error";
    const small = formGroup.querySelector("small");
    small.innerText = msg;
  }

  //Input Success message function

  function successMsg(input) {
    const formGroup = input.parentElement;
    formGroup.className = "form-group success";
  }
  //Check every field function
  function checkRequired(inputArr) {
    inputArr.forEach(function (input) {
      if (input.value.trim() === "") {
        errorMsg(input, `${getFieldName(input)} is required`);
      }
    });
  }

  //Email validation
  function checkValidEmail(input) {
    const emailPattern = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    // return emailPattern.test(String(email).toLowerCase())
    if (emailPattern.test(input.value.trim())) {
      successMsg(input);
    } else {
      errorMsg(input, `Email is not valid`);
    }
  }
  //Check username and password length
  function checkLength(input, min, max) {
    if (input.value.length < min) {
      errorMsg(
        input,
        `${getFieldName(input)} must be greater than ${min} characters`
      );
    } else if (input.value.length > max) {
      errorMsg(
        input,
        `${getFieldName(input)} must be less than ${max} characters`
      );
    } else {
      successMsg(input);
    }
  }

  // Check password confirmation
  function checkMatchPwd(input1, input2) {
    if (input1.value !== input2.value) {
      errorMsg(input2, "Passwords do not match");
    }
  }
  //Get all field name function
  function getFieldName(input) {
    // return input.id.charAt(0).toUpperCase().concat(input.name.slice(1));
    return input.id.charAt(0).toUpperCase() + input.id.slice(1);
  }

  //Form Submission event actions
  form.addEventListener("submit", (event) => {
    event.preventDefault();

    checkRequired([username, email, password, password2]);
    checkLength(username, 3, 15);
    checkLength(password, 6, 15);
    checkValidEmail(email);
    checkMatchPwd(password, password2);
  });
})();
